export default "__VITE_ASSET__BYj7RE36__"